export type DeviceType =
  | "extraLarge"
  | "large"
  | "medium"
  | "tablet"
  | "largeMobile"
  | "mobile"
  | "smallMobile";

/**
 * Maximum widths in px for a screen
 * to be considered each type of
 * device.
 */
export const deviceBreakpoints: Record<DeviceType, number> = {
  extraLarge: 1800,
  large: 1440,
  medium: 1024,
  tablet: 768,
  largeMobile: 480,
  mobile: 375,
  smallMobile: 320,
};

const customMediaQuery = (maxWidth: number) =>
  `@media (max-width: ${maxWidth}px)`;

export const mediaQueries = {
  custom: customMediaQuery,
  extraLarge: customMediaQuery(deviceBreakpoints.extraLarge),
  large: customMediaQuery(deviceBreakpoints.large),
  medium: customMediaQuery(deviceBreakpoints.medium),
  tablet: customMediaQuery(deviceBreakpoints.tablet),
  largeMobile: customMediaQuery(deviceBreakpoints.largeMobile),
  mobile: customMediaQuery(deviceBreakpoints.mobile),
  smallMobile: customMediaQuery(deviceBreakpoints.smallMobile),
};
